import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PipesModule } from '../../../shared/pipes/pipes.module';
import { TransPipe } from '../../../shared/pipes/trans.pipe';
import { PositiveRulesDropdownComponent } from './active-rules-dropdown/positive-rules-dropdown.component';
import { AssignmentTypeDropdownComponent } from './assignment-type-dropdown/assignment-type-dropdown.component';
import { BrandSelectionDropdownComponent } from './brand-selection-dropdown/brand-selection-dropdown.component';
import { ChannelSelectionDropdownComponent } from './channel-selection-dropdown/channel-selection-dropdown.component';
import { CompanySelectionDropdownComponent } from './company-selection-dropdown/company-selection-dropdown.component';
import { ConcurrenceConfigDropdownComponent } from './concurrence-config-dropdown/concurrence-config-dropdown.component';
import { DealerSelectionDropdownComponent } from './dealer-selection-dropdown/dealer-selection-dropdown.component';
import { DropDownService } from './dropdown.service';
import { DropdownsWithRulesDropdownComponent } from './dropdowns-with-rules-dropdown/dropdowns-with-rules-dropdown.component';
import { NotificationTypeDropdownComponent } from './notification-type-dropdown/notification-type-dropdown.component';
import { OriginSelectionDropdownComponent } from './origin-selection-dropdown/origin-selection-dropdown.component';
import { ActiveRulesDropdownComponent } from './positive-rules-dropdown/active-rules-dropdown.component';
import { TimeZoneDropdownComponent } from './timezone-dropdown/timezone-dropdown.component';
import { TrackingEmailConfigDropdownComponent } from './tracking-email-config-dropdown/tracking-email-config-dropdown';
import { TypeSelectionDropdownComponent } from './type-selection-dropdown/type-selection-dropdown.component';
import { UserSelectionByRoleDropdownComponent } from './user-selection-by-role-dropdown/user-selection-by-role-dropdown.component';
import { UserSelectionDropdownComponent } from './user-selection-dropdown/user-selection-dropdown.component';

@NgModule({
  declarations: [
    BrandSelectionDropdownComponent,
    ChannelSelectionDropdownComponent,
    DealerSelectionDropdownComponent,
    TypeSelectionDropdownComponent,
    UserSelectionByRoleDropdownComponent,
    UserSelectionDropdownComponent,
    CompanySelectionDropdownComponent,
    NotificationTypeDropdownComponent,
    AssignmentTypeDropdownComponent,
    TimeZoneDropdownComponent,
    ConcurrenceConfigDropdownComponent,
    TrackingEmailConfigDropdownComponent,
    ActiveRulesDropdownComponent,
    PositiveRulesDropdownComponent,
    DropdownsWithRulesDropdownComponent,
    OriginSelectionDropdownComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    FormsModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  exports: [
    BrandSelectionDropdownComponent,
    ChannelSelectionDropdownComponent,
    DealerSelectionDropdownComponent,
    TypeSelectionDropdownComponent,
    UserSelectionByRoleDropdownComponent,
    UserSelectionDropdownComponent,
    CompanySelectionDropdownComponent,
    NotificationTypeDropdownComponent,
    AssignmentTypeDropdownComponent,
    TimeZoneDropdownComponent,
    ConcurrenceConfigDropdownComponent,
    TrackingEmailConfigDropdownComponent,
    ActiveRulesDropdownComponent,
    PositiveRulesDropdownComponent,
    DropdownsWithRulesDropdownComponent,
    OriginSelectionDropdownComponent
  ],
  providers: [
    DropDownService,
    TransPipe
  ]
})
export class DropdownModule { }
